import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

import {CalendarComponent} from './calendar.component';
import {CalendarHeaderComponent} from './calendar-header/calendar-header.component';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {CUSTOM_FORMATS} from '../../app.constants';
import {CalendarService} from './calendar.service';
import {CustomDateAdapter} from '../../shared/custom-date-adapter';


@NgModule({
  declarations: [
    CalendarComponent,
    CalendarHeaderComponent
  ],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
  ],
  providers: [
    CalendarService,
    {provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_LOCALE, useValue: 'ru-RU'},
    {provide: MAT_DATE_FORMATS, useValue: CUSTOM_FORMATS}
  ],
  exports: [
    CalendarComponent,
    CalendarHeaderComponent
  ]
})
export class CalendarModule {
}
